// import React from 'react';
// import GameRating from './header/GameRating';
// import MovieRating from './header/MovieRating';
// import TvRating from './header/TvRating';
// import Header from './header/Header';

// export default function RatingHeader({ cat, content }) {
//   switch (cat) {
//     case 'movie':
//       return <MovieRating content={content} />;
//     case 'tv':
//       return <TvRating content={content} />;
//     case 'game':
//       return <GameRating content={content} />;
//     // neww add
//     case 'articles':
//       return <Header content={content} />;
//     case 'beverages':
//       return <Header content={content} />;
//     case 'cinemas':
//       return <Header content={content} />;
//     case 'cpg':
//       return <Header content={content} />;
//     case 'applicationprocess':
//       return <Header content={content} />;
//     case 'class':
//       return <Header content={content} />;
//     case 'collision':
//       return <Header content={content} />;
//     case 'delivery':
//       return <Header content={content} />;
//     case 'applicationprocess':
//       return <h1 className="text-white">{cat}</h1>;
//   }
// }

import React from 'react';
import GameRating from './header/GameRating';
import MovieRating from './header/MovieRating';
import TvRating from './header/TvRating';
import Header from './header/Header';

const componentMap = {
  movie: MovieRating,
  tv: TvRating,
  television: TvRating,
  game: GameRating,
  videogame: GameRating,
  videogames: GameRating,
};

function normalizeCategory(cat) {
  if (!cat) return '';
  const decoded = decodeURIComponent(cat);
  return decoded.toLowerCase().replace(/[\s-_]/g, '');
}

export default function RatingHeader({ cat, content }) {
  const normalizedCat = normalizeCategory(cat);
  const Component = componentMap[normalizedCat] || Header;

  return <Component content={content} />;
}
